import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "14700238-14e3-4abb-b829-e034d3976e19",
    content: "Convolution of two continuous functions is a continuous function ",
    options: {},
  },
  {
    id: "89c1318a-8712-4951-8425-30800712b6a3",
    content: "Convolution of two discontinuous functions is a continuous function ",
    options: {},
  },
  {
    id: "d2d4efc0-0fbe-4ffe-a2d5-9205e33e1adb",
    content: "Dirac delta is the neutral element of convolution",
    options: {},
  },
  {
    id: "d104abb8-be1e-4f30-b210-c239d9242d21",
    content: "The impulse response in an infinite 3D space is a delayed Dirac delta",
    options: {},
  },
  { id: "74090f58-206a-419a-847c-dad27c6440a4", content: "f*g = g*f only in special cases", options: {} },
  {
    id: "47015a4a-93c9-407d-87a9-de5744e743d4",
    content: "The impulse response of a cascade of LTI systems depends on their order",
    options: {},
  },
  {
    id: "685169df-2bf4-4670-8afc-ec96e6ec3679",
    content: "The impulse response of a system cannot go to infinity",
    options: {},
  },
];

export const task: Task = {
  id: "c1df359b-8026-4233-b08e-b68f7d9a8ee5",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "14700238-14e3-4abb-b829-e034d3976e19",
    "89c1318a-8712-4951-8425-30800712b6a3",
    "d2d4efc0-0fbe-4ffe-a2d5-9205e33e1adb",
    "d104abb8-be1e-4f30-b210-c239d9242d21",
  ],
};
